import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";
import { Form } from "react-bootstrap";

const SelectField = ({
    controlId,
    label,
    name,
    options,
    register,
    errors,
    required,
}) => {
    const { language } = useTranslation();
    return (
        <Form.Group controlId={controlId}>
            <Form.Label>
                {label}
                {required && <span className="required">*</span>}
            </Form.Label>
            <Form.Control
                name={name}
                as="select"
                ref={register}
                isInvalid={errors[name]}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Form.Control>
            {language !== "es" && (
                <Form.Control.Feedback type="invalid">
                    {errors[name] && errors[name].message}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};

export default SelectField;